import { MDCRipple } from '@material/ripple';
export const setupRippleEffect = (rootElement) => {
    if ('reduceAnimations' in document.body.dataset) {
        return;
    }
    const rippleElements = [
        '.button-primary',
        '.button-secondary',
        '.slideshow-slide__button',
        '.product-form--atc-button',
        '.mobile-nav-content .navmenu-link',
        '.mobile-nav-content .navmenu-button',
        '.mobile-nav-primary-content .navmenu-link',
        '.mobile-nav-primary-content .navmenu-button',
        '.live-search-button',
        '.form-options-selectable-boxes .option-value-name',
    ];
    rootElement.querySelectorAll(rippleElements.join(',')).forEach((el) => {
        if (!el.classList.contains('disabled') && !el.hasAttribute('disabled')) {
            el.classList.add('mdc-ripple-surface');
            MDCRipple.attachTo(el);
        }
    });
};
/* harmony default export */ const Ripple = {
    setupRippleEffect,
};
